import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProjectForm } from '../components/ProjectForm';
import { ProjectPreview } from '../components/ProjectPreview';
import { ProjectFormData } from '../types/project';
import { User } from '../types';

interface CreateProjectPageProps {
  currentUser: User;
}

export const CreateProjectPage: React.FC<CreateProjectPageProps> = ({ currentUser }) => {
  const navigate = useNavigate();
  const [showPreview, setShowPreview] = useState(false);
  const [projectData, setProjectData] = useState<ProjectFormData | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSave = async (formData: ProjectFormData) => {
    setIsSubmitting(true);
    
    try {
      // Here you would save to Supabase
      console.log('Saving project:', formData);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Clear draft from localStorage
      localStorage.removeItem('projectDraft');
      
      // Navigate to project page or dashboard
      navigate('/projects');
      
    } catch (error) {
      console.error('Error saving project:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePreview = (formData: ProjectFormData) => {
    setProjectData(formData);
    setShowPreview(true);
  };

  const handleBackToEdit = () => {
    setShowPreview(false);
  };

  const handleConfirmPublish = () => {
    if (projectData) {
      handleSave(projectData);
    }
  };

  if (showPreview && projectData) {
    return (
      <ProjectPreview
        projectData={projectData}
        onBack={handleBackToEdit}
        onConfirm={handleConfirmPublish}
        isSubmitting={isSubmitting}
      />
    );
  }

  return (
    <ProjectForm
      onSave={handleSave}
      onPreview={handlePreview}
      isSubmitting={isSubmitting}
    />
  );
};